import * as THREE from "three";
import { SpecificController } from "@components/SpecificController";
import { OverlayInterface } from "@components/UI/OverlayInterface";
export class SpectatorController extends SpecificController {

    get input() { return this.gameObject.engine.input }
    instructionOverlay!: OverlayInterface
    setup(_data: any) {
        super.setup(_data)
    }
    start() {
        this.instructionOverlay = this.gameObject.addComponent(OverlayInterface, {
            innerHTML: `
            <div style="position: absolute; bottom: 20px; left: 50%; transform: translateX(-50%); font-size: 24px; color: white; background: rgba(0, 0, 0, 0.5);padding: 10px; border: none; border-radius: 10px;">
                <span style = "color: white; font-family: Arial, sans-serif; font-size: 24px;">Utilisez ZQSD pour se deplacer <br>La souris + click gauche pour tourner la camera <br>Espace pour monter et shift pour descendre <br>ESC pour quitter</span>
            </div>
        `})
    }
    updateActions(_dt: number): void {
        if (this.input.onPress('Escape')) {
            console.log('removed spectate controller')
            this.gameObject.removeComponent(this)
        }

        const accel = _dt * 20
        const inputAxisX = this.input.getAxis('KeyD', 'KeyA')
        const inputAxisY = this.input.getAxis('KeyS', 'KeyW')
        const inputAxisZ = this.input.getAxis('Space', 'ShiftLeft')

        const lookVec = this.transform.forward.normalize()
        const rightVec = this.transform.VectorLocalToWorld(new THREE.Vector3(1, 0, 0)).normalize()

        let speed = new THREE.Vector3(0, 0, 0)
        speed = speed.add(lookVec.clone().multiplyScalar(inputAxisY))
        speed = speed.add(new THREE.Vector3(0, 1, 0).multiplyScalar(inputAxisZ))
        speed = speed.add(rightVec.clone().multiplyScalar(inputAxisX))
        this.targetTransform.position.add(speed.multiplyScalar(accel))

        // rotation system
        const mouseMove = (new THREE.Vector2(this.input.mouse.movementX, - this.input.mouse.movementY)).multiplyScalar(0.01)
        if (this.input.mouse.leftClick) {
            //stuck mouse cursor
            this.engine.canvas!.requestPointerLock();
            //corectly set order to zyx but saving same rotation with the last order
            if (this.targetTransform.rotation.order !== 'ZYX') {
                this.targetTransform.lookAlong(this.targetTransform.forward.negate(), 'ZYX')
                //this.targetTransform.rotation.z = 0
                if (this.targetTransform.rotation.z != 0) {
                    this.targetTransform.rotation.z = 0
                    this.targetTransform.rotation.x += Math.PI
                    this.targetTransform.rotation.y = Math.PI - this.targetTransform.rotation.y
                }
            }

            this.targetTransform.rotation = new THREE.Euler(this.targetTransform.rotation.x + mouseMove.y, this.targetTransform.rotation.y - mouseMove.x, this.targetTransform.rotation.z, 'ZYX')
            // clamp rotation
            //if (this.targetTransform.rotation.x > Math.PI / 2) this.targetTransform.rotation.x = Math.PI / 2
            //if (this.targetTransform.rotation.x < -Math.PI / 2) this.targetTransform.rotation.x = -Math.PI / 2
        }
        else {
            document.exitPointerLock();
        }

    }
    update(_dt: number) {

    }
    onMove() {
    }
    onDestroy() {
        this.playerController.setDistanceSavingCameraPosition(0)
        this.instructionOverlay.remove()
        super.onDestroy()
    }
}